import React from 'react';
import { FormControl, FormHelperText, Button } from '@material-ui/core';
import AddRoadRoundedIcon from '@mui/icons-material/AddRoadRounded';

export function useMultiSelect(initialFValues = [], validateOnChange = false, validate = () => {}) {
  const [selection, setSelection] = React.useState(Array.isArray(initialFValues) ? initialFValues : []);
  const [error, setError] = React.useState(undefined);

  const handleInputChange = (e) => {
    const value = e?.target?.value || [];
    const safeValue = Array.isArray(value) ? value : [];

    setSelection(safeValue);

    if (validateOnChange) {
      validate(safeValue);
    }
  };

  const resetSelect = () => {
    setSelection(Array.isArray(initialFValues) ? initialFValues : []);
    setError(undefined);
  };

  return {
    selection,
    setSelection,
    error,
    setError,
    handleInputChange,
    resetSelect,
  };
}

export const MultiSelect = (props) => {
  const { error = null, label, style, onOpen } = props;

  const handleOpenMenu = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const rect = event.currentTarget.getBoundingClientRect();

    onOpen?.({
      top: Math.round(rect.bottom + 8),
      left: Math.round(rect.left),
    });
  };

  return (
    <FormControl variant="outlined" {...(error && { error: true })}>
      <div style={{ display: 'inline-block' }}>
        <Button
          onClick={handleOpenMenu}
          style={{
            color: '#6200EE',
            width: '185px',
            fontSize: '14px',
            lineHeight: '16px',
            fontFamily: 'canalfont-regular',
            ...style,
          }}
          startIcon={<AddRoadRoundedIcon />}
        >
          {label}
        </Button>
      </div>

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
